import {
  commandResultSchema,
  passportBootstrapSchema,
  passportPageDetailSchema,
  stampDetailSchema,
  type PassportCommand,
} from "@peer-start/platform-contracts";
import { request } from "../../prototype/api/client.js";

export function fetchPassportBootstrap() {
  return request("/api/passport/bootstrap", passportBootstrapSchema);
}

export function fetchPassportPage(employeeId: string, pageId: string) {
  return request(
    `/api/employees/${encodeURIComponent(employeeId)}/passport-pages/${encodeURIComponent(pageId)}`,
    passportPageDetailSchema,
  );
}

export function fetchStampDetail(employeeId: string, stampId: string) {
  return request(
    `/api/employees/${encodeURIComponent(employeeId)}/stamps/${encodeURIComponent(stampId)}`,
    stampDetailSchema,
  );
}

export function sendPassportCommand(command: PassportCommand) {
  return request("/api/passport/commands", commandResultSchema, {
    method: "POST",
    headers: { "Idempotency-Key": crypto.randomUUID() },
    body: JSON.stringify(command),
  });
}
